import { useDispatch, useSelector } from "react-redux";
import {
  ElementLibraryModalProps,
  SelectLibraryElementProps,
  elementLibraryModalActions,
} from "store/elementLibrarySlice";
import { AppDispatch, RootState } from "store/store";
import elementLibraryModalThunkActions from "store/thunk/elementLibraryThunkActions";

export const useElementLibrary = () => {

  // Hooks
  const dispatch: AppDispatch = useDispatch();

  const { isOpen, elementTypeFilter } = useSelector((state: RootState) => ({
    isOpen: state.elementLibraryModal.isOpen,
    elementTypeFilter: state.elementLibraryModal.elementTypeFilter ?? "",
  }));

  // Handler
  const openElementLibraryModal = async (props: ElementLibraryModalProps) => {
    const { payload } = await dispatch(
      elementLibraryModalThunkActions.openElementLibraryThunk(props)
    );

    return payload;
  };

  const closeElementLibraryModal = () => {
    return dispatch(elementLibraryModalActions.closeElementLibraryModal());
  };

  const selectLibraryElement = async (props: SelectLibraryElementProps) => {
    const { payload } = await dispatch(
      elementLibraryModalThunkActions.selectLibraryElementThunk(props)
    );
    return payload;
  };

  return {
    isOpen,
    elementTypeFilter,
    openElementLibraryModal,
    closeElementLibraryModal,
    selectLibraryElement,
  };
};

export default useElementLibrary;
